// These service names are defined here https://admin.usercentrics.eu/#/v2/service-settings/data-processing-services?settingsId=gArbwCTa2irRgd

export enum ServiceName {
  DATADOG = "Datadog Real User Monitoring",
  SEGMENT = "Segment",
}
